import { __, __cases } from "@libs/utilities"
import { IPEFestSchool } from "../../data/interfaces"
import { getFeedRoute, getRoute, getRouteByComponent } from "@libs/layouts"
import { useNavigate } from "react-router"
import { Button, Popover, Position, Tooltip } from "@blueprintjs/core"
import QRCodeButton from "@/modules/pe-basic-module/views/core/QRCodeButton"
import Bookmark from "@libs/useful/Bookmark"
import { Likes } from "@libs/useful"

/* Protopia Ecosystem component */
export interface IFestSchoolCardProps {
   item: IPEFestSchool
}
const FestSchoolCard = (props: IFestSchoolCardProps): JSX.Element => {
    const navigate = useNavigate()
    const routeSingle = getFeedRoute("PEFestProject") 
    const _url = routeSingle
        ? 
        `/${ getRoute(routeSingle)}?schools=-1,${ props.item.id }` 
        : 
        "/"
    const onClick = () => {
        navigate( _url )
    }
    const onCancelClick = (evt: any) => {
      evt.stopPropagation()
      evt.preventDefault() 
    }
    return <div className="col-md-6 mb-0 py-2 px-0 strob-tile " data-testid="school-card-cont">
        <div className="container h-100">
            <div className="row pb-1 h-100">
                <div className="col-md-6  my-auto" data-testid="school-card-title">
                    <h5 
                        className="m-0 w-100 pointer" 
                        style={{ lineHeight: .9 }} 
                        onClick={onClick}
                    >
                        { props.item.title }  
                    </h5>
                    {
                        !!props.item.destrict.length &&
                        <div className=" small " >
                            { props.item.destrict[0].title }
                        </div>
                    }
                </div> 
                <div className="col-md-4 cl-6 my-auto" data-testid="school-card-guardians">
                    {
                        props.item.guardian?.id && 
                        <div className="small">
                            <div className=" small descr" >
                                { __(!!props.item.guardian2 ? "School_guardians" : "School_guardian") }:
                            </div>
                            <Tooltip
                                position={Position.TOP_LEFT}
                                content={<div className="p-0 small">{__("Send message")}</div>}
                            >
                                <div className=" pointer hover" onClick={() => navigate( `/${getRoute( getFeedRoute("PEMessage") )}/user/${props.item.guardian?.id}` )}>
                                    {props.item.guardian?.display_name}
                                </div>
                            </Tooltip>
                            
                            <Tooltip
                                position={Position.TOP_LEFT}
                                content={<div className="p-0 small">{__("Send message")}</div>}
                            >
                                <div className=" pointer hover" onClick={() => navigate( `/${getRoute( getFeedRoute("PEMessage") )}/user/${props.item.guardian2?.id}` )}>
                                    {props.item.guardian2?.display_name}
                                </div> 
                            </Tooltip>
                        </div>
                    }                    
                </div>
                <div className="col-md-2 col-6 my-auto d-flex align-items-center justify-content-between pr-0" data-testid="school-card-count">
                    <div className="small flex-grow-100">
                        <span className='mr-2'>{ props.item.count || 0 }</span>
                        <span className="small">{__cases(props.item.count, "projects")}</span>
                    </div>
                    <div className="float-right pe-surface2" onClick={onCancelClick}>
                        <Popover
                            interactionKind='hover'
                            position={Position.TOP_RIGHT}
                            content={
                                <>
                                    <QRCodeButton 
                                        item={props.item} 
                                        options={{
                                            text:`${window.location.origin}/${getRouteByComponent("FestivalView")?.realRoute}/members?tack=${props.item.id}`, 
                                            title: '',
                                            width:  410,
                                            height: 410, 
                                        }} 
                                    />
                                    <Bookmark item={ props.item } />
                                    <Likes item={ props.item } dataType='PEFestTrack' className='' /> 
                                </>
                            }
                        >
                            <Button  variant="minimal" data-testid="school-card-more">
                                <i className="fas fa-ellipsis-v opacity_5 hover" />
                            </Button>
                        </Popover> 
                    </div>
                </div>
            </div>
        </div>
    </div>

    
}
export default FestSchoolCard

const MiddleSchoolCard = (props: IFestSchoolCardProps): JSX.Element  => {
    const navigate = useNavigate()
    const routeSingle = getFeedRoute("PEFestProject") 
    const _url = routeSingle
        ? 
        `/${ getRoute(routeSingle)}?schools=-1,${ props.item.id }` 
        : 
        "/"
    const onClick = () => {
        navigate( _url )
    }
    return <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-4">
       <div 
            className="card h-100 m-0 p-0 position-relative"  
        >
            <div
                className="card-img border-none overflow-hidden hover pointer d-flex align-items-end "
                style={{
                    backgroundImage: `url(${props.item.thumbnail})`,
                    height: 130,
                    backgroundSize: "cover",
                    backgroundRepeat:"no-repeat"
                }} 
                onClick={onClick}
            > 
                {
                    !!props.item.destrict.length &&
                    <div className="pe-narrow-pennant pe-dark small text-uppercase" >
                        { props.item.destrict[0].title }
                    </div>
                }
            </div> 
            <div
                className="card-header d-flex flex-centered flex-column pb-3"
                title={ props.item.title }
                style={{
                    height: 125,
                    overflow: "hidden",
                    padding: "0 1.25em",
                    position: "relative",
                    display: "table",
                    paddingTop: 14
                }}
            >
                <h5 
                    className="m-0 w-100 text-center pointer" 
                    style={{ lineHeight: 1.0 }} 
                    onClick={onClick}
                >
                    { props.item.title }  
                </h5>
                <div>
                    <div className="btn btn-link px-3 py-1">
                        {props.item.guardian?.display_name}
                    </div> 
                </div>
                <div>
                    <span className='mr-2'>{ props.item.count || 0 }</span>
                    <span>{__cases(props.item.count, "projects")}</span>
                </div>
            </div>
            <ul className="list-group list-group-flush flex-grow-100 ">
                <li className="list-group-item h-100 d-flex flex-column">
                    
                </li>
            </ul>
        </div>
    </div>
}